<template>
	<div id="HomePage">
		<!--轮播图 默认swiper带分页器导航按钮,注释不用 -->
		<!-- <div id="swiper" class="container-fuild">
			<div class="swiper-container banner-swiper">
				<div class="swiper-wrapper">
				<div class="swiper-slide" v-for="(item,index) in swiperList" :key="index">
					<img class="swiper-lazy" :data-src="item.img" alt="轮播图">
					<div class="swiper-lazy-preloader"></div>
					<div class="swiper-slide-title">
						<h1>{{item.title}}</h1>
						<p>{{item.content}}</p>
					</div>
				</div>
				</div>
				<div class="swiper-pagination"></div>
				<div class="swiper-button-prev"></div>
				<div class="swiper-button-next"></div>
			</div>
		</div>-->

		<!-- 轮播图 启用element走马灯 -->
		<div id="swiper" class="container-fuild relative">
			<el-carousel
				:autoplay="true"
				:interval="5000"
				:loop="true"
				indicator-position="none"
				:height="`1080px`"
				style="width:100%"
			>
				<el-carousel-item v-for="item,index in carouselList" :key="index">
					<!-- jet1207 后续若加入文字需设置绝对定位并在走马灯组件内部加入文字 -->
					<el-image style="width:100%; height:auto" :src="item.img" fit="fill"></el-image>
				</el-carousel-item>
			</el-carousel>

			<!-- 企业简介(绝对定位) -->
			<div id="desc" class="container-fuild absolute">
				<div class="row">
					<!-- 电脑端简介 -->
					<div class="description_md hidden-xs hidden-sm col-md-8 col-md-offset-2 wow zoomIn">
						<div class="title fontsize_40 font_bold w_100 color_blue p_10">
							集团简介
							<span class="green">Group profile</span>
						</div>
						<div class="content flex justify_start align_center w_100 p_10">
							<div class="w_30 p_10 pl_0">
								<el-image
									style="width:100%; height:auto"
									:src="require('@/assets/img/desc.jpg')"
									fit="fill"
								></el-image>
							</div>
							<div
								class="groupdesc w_70 p_10 text_gray flex flex_column justify_between align_start fontsize_20">
								<div>   山东杰出人才发展集团（以下称：杰出集团）总部位于山东日照人力资源服务产业园，山东省领军人力资源服务企业，成立于2008年8月，是一家专业提供定制化人力资源管理咨询与人力资源服务方案的集团化公司，品牌价值7500万。旗下现有29家分支机构，总实缴注册资本2000万元。在上海虹桥国际商务人才港设立第二战略总部，在济南和青岛设立区域市场总部。</div>
								<p class="knowmore" @click="goToAboutGroup">了解更多></p>
							</div>
						</div>
					</div>

					<!-- 手机端简介 -->
					<div class="description_xs visible-xs visible-sm col-xs-12 col-sm-12 wow zoomIn">
						<div class="title fontsize_24 font_bold w_100 color_blu p_10 pb_0">
							集团简介
							<span class="green">Group profile</span>
						</div>
						<div class="content flex flex_column justify_start align_center w_100 p_10">
							<div class="w_100 pt_10 pb_10">
								<el-image
									style="width:100%; height:auto"
									:src="require('@/assets/img/desc.jpg')"
									fit="contain"
								></el-image>
							</div>
							<div
								class="w_100 pt_10 pb_10  text_gray flex flex_column justify_between align_start fontsize_14"
								style="height:210px;"
							>
								<div class="text_indent_2">山东杰出人才发展集团有限公司成立于2008年，总部位于山东日照人力资源服务产业园，是一家专业提供定制化管理咨询与服务方案的集团化公司，下设27家分支机构，注册资金1.74亿人民币。业务覆盖全国50多个城市，累计已为2000余家企业提供专业人力资源服务，服务50余万人次。</div>
								<p class="knowmore" @click="goToAboutGroup">了解更多></p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- 统计数字 电脑端-->
		<div id="summary_md" class="hidden-xs hidden-sm container-fuild">
			<div class="row">
				<div class="col-md-10 col-md-offset-1">
					<div
						v-for="item,index in summaryList"
						:key="index"
						class="col-md-4 flex flex_column justify_between align_center pt_50 pb_50"
					>
						<div class="fontsize_70 font_bold color_blue">
							<span class="number">
								<i-count-up
									:start="0"
									:endVal="parseInt(item.val)"
									:decimals="0"
									:duration="4.5"
									:delay="2000"
									:options="CountUpOptions"
								></i-count-up>
							</span>

							<span class="fontsize_30 font_normal">{{item.unit}}</span>
						</div>
						<div class="fontsize_24 font_500 text_gray">{{item.name}}</div>
					</div>
				</div>
			</div>
		</div>

		<!-- 统计数字 手机端 -->
		<div id="summary_xs" class="visible-xs visible-sm container-fuild">
			<div class="row">
				<div class="col-xs-8 col-xs-offset-2">
					<div
						v-for="item,index in summaryList"
						:key="index"
						class="col-md-4 flex flex_column justify_between align_center pt_16 pb_16"
					>
						<div class="fontsize_40 font_bold color_blue">
							<span class="number">
								<i-count-up
									:start="0"
									:endVal="parseInt(item.val)"
									:decimals="0"
									:duration="4.5"
									:delay="2000"
									:options="CountUpOptions"
								></i-count-up>
							</span>
							<span class="fontsize_24 font_normal">{{item.unit}}</span>
						</div>
						<div class="fontsize_18 font_500 text_gray">{{item.name}}</div>
					</div>
				</div>
			</div>
		</div>

		<!-- 集团业务 -->
		<div id="business" class="container-fuild">
			<!-- 电脑端 -->
			<div id="business_md" class="row hidden-xs hidden-sm">
				<!-- 标签 -->
				<div class="tag col-md-4 col-md-offset-4 wow bounceInDown">
					<div class="title fontsize_40 font_bold w_100 color_blue text_center">
						集团业务
						<span class="green">Group business</span>
					</div>
				</div>
				<!-- 正文 -->
				<div class="content">
					<!-- part1 -->
					<div class="mt_20 col-md-6 col-md-offset-3">
						<!-- 嵌套element栅格 使用分栏间隔gutter-->
						<el-row :gutter="20">
							<el-col :span="8" v-for="item,index in businessList1" :key="index">
								<div
									@click="goToGroupBusiness(item.index)"
									class="item flex flex_column justify_start align_center wow slideInUp"
								>
									<el-image class="businessImg" style="width:160px; height:160px;padding:15px" :src="item.img" fit="contain"></el-image>
									<el-image class="businessImgHover" style="width:160px; height:160px;padding:15px" :src="item.imgHover" fit="contain"></el-image>
									<div class="fontsize_20 line_height_normal color_blue">{{item.name}}</div>
									<div class="fontsize_16 pt_10 line_height_normal text_gray">{{item.desc}}</div>
									<p class="fontsize_16 pt_20 line_height_normal green">了解更多></p>
								</div>
							</el-col>
						</el-row>
					</div>

					<!-- part2 -->
					<div class="mt_20 col-md-8 col-md-offset-2">
						<!-- 嵌套element栅格 使用分栏间隔gutter-->
						<el-row :gutter="20">
							<el-col :span="6" v-for="item,index in businessList2" :key="index">
								<div
									@click="goToGroupBusiness(item.index)"
									class="item flex flex_column justify_start align_center wow slideInUp"
								>
									<el-image class="businessImg" style="width:160px; height:160px;padding:15px" :src="item.img" fit="contain"></el-image>
									<el-image class="businessImgHover" style="width:160px; height:160px;padding:15px" :src="item.imgHover" fit="contain"></el-image>									
									<div class="fontsize_20 line_height_normal color_blue">{{item.name}}</div>
									<div class="fontsize_16 pt_10 line_height_normal text_gray">{{item.desc}}</div>
									<p class="fontsize_16 pt_20 line_height_normal green">了解更多></p>
								</div>
							</el-col>
						</el-row>
					</div>
				</div>
			</div>

			<!-- 手机端 -->
			<div id="business_xs" class="row visible-xs visible-sm">
				<!-- 标签 -->
				<div class="tag col-xs-10 col-xs-offset-1 wow bounceInDown">
					<div class="title fontsize_24 font_bold w_100 color_blue text_center">
						集团业务
						<span class="green">Group business</span>
					</div>
				</div>
				<!-- 正文 -->
				<div class="content">
					<!-- part1 -->
					<div class="mt_20 col-xs-10 col-xs-offset-1">
						<!-- 嵌套element栅格 使用分栏间隔gutter-->
						<el-row :gutter="10">
							<el-col :span="24" v-for="item,index in businessList1" :key="index">
								<div
									@click="goToGroupBusiness(item.index)"
									class="item flex flex_column justify_start align_center mt_12 wow slideInUp"
								>
									<el-image class="businessImg" style="width:160px; height:160px;padding:15px" :src="item.img" fit="contain"></el-image>
									<el-image class="businessImgHover" style="width:160px; height:160px;padding:15px" :src="item.imgHover" fit="contain"></el-image>
									<div class="fontsize_20 line_height_normal color_blue">{{item.name}}</div>
									<div class="fontsize_16 pt_10 line_height_normal text_gray">{{item.desc}}</div>
									<p class="fontsize_16 pt_20 line_height_normal green">了解更多></p>
								</div>
							</el-col>
						</el-row>
					</div>

					<!-- part2 -->
					<div class="mt_20 col-xs-10 col-xs-offset-1">
						<!-- 嵌套element栅格 使用分栏间隔gutter-->
						<el-row :gutter="10">
							<el-col :span="24" v-for="item,index in businessList2" :key="index">
								<div
									@click="goToGroupBusiness(item.index)"
									class="item flex flex_column justify_start align_center mt_12 wow slideInUp"
								>
									<el-image class="businessImg" style="width:160px; height:160px;padding:15px" :src="item.img" fit="contain"></el-image>
									<el-image class="businessImgHover" style="width:160px; height:160px;padding:15px" :src="item.imgHover" fit="contain"></el-image>									
									<div class="fontsize_20 line_height_normal color_blue">{{item.name}}</div>
									<div class="fontsize_16 pt_10 line_height_normal text_gray">{{item.desc}}</div>
									<p class="fontsize_16 pt_20 line_height_normal green">了解更多></p>
								</div>
							</el-col>
						</el-row>
					</div>
				</div>
			</div>
		</div>

		<!-- 业务版图 -->
		<div id="territory" class="container-fuild mt_36">
			<!-- 电脑端 -->
			<div id="territory_md" class="row hidden-xs hidden-sm wow zoomIn">
				<el-image
					style="width:100%; height:auto"
					:src="require('@/assets/img/territory.jpg')"
					fit="contain"
				></el-image>
			</div>

			<!-- 手机端 -->
			<div id="territory_xs" class="row visible-xs visible-sm wow zoomIn">
				<el-image
					style="width:100%; height:auto"
					:src="require('@/assets/img/territory.jpg')"
					fit="contain"
				></el-image>
			</div>
		</div>

		<!-- jet0627 集团宣传片 仅限电脑端-->
		<div id="business" class="container-fuild">
			<!-- 电脑端 -->
			<div id="business_md" class="row hidden-xs hidden-sm">
				<!-- 标签 -->
				<div class="tag col-md-6 col-md-offset-3 wow bounceInDown">
					<div class="title fontsize_40 font_bold w_100 color_blue text_center">
						集团宣传片
						<span class="green">Promotional video</span>
					</div>
				</div>
				<!-- 宣传视频 -->
				<div style="height:600px" class="col-md-10 col-md-offset-1 mt_60">
					<!-- position:relative;right:33%;top:35% -->
					<video style="width:100%; height:100%; object-fit: cover;border-radius: 10px;box-shadow: 0 0 10px #000;" class="my-video" controls>
						<source src="../assets/video/jituanvideo.mp4" type="video/mp4">Your browser does not support the video tag
					</video>
				</div>
			</div>
		</div>	

		<!-- 杰出资讯 -->
		<div id="information" class="container-fuild mt_36">
			<!-- 电脑端 -->
			<div id="information_md" class="row hidden-xs hidden-sm">
				<!-- 标签 -->
				<div class="tag col-md-6 col-md-offset-3 wow bounceInDown">
					<div class="title fontsize_40 font_bold w_100 color_blue text_center">
						杰出资讯
						<span class="green">Group information</span>
					</div>
				</div>
				<!-- 菜单分类 -->
				<div class="navItem col-md-10 col-md-offset-1 mt_60 pt_10 pb_10">
					<div class="col-md-4">
						<div class="navTitle fontsize_30">
							<span
								v-for="item,index in informationNavItemList"
								:key="index"
								@click="changeNavItem(index)"
								class="font_600 wow zoomInLeft"
								:class="{color_blue: currentIndex == index}"
							>{{item.navName}}</span>
						</div>
					</div>
					<div
						@click="goToGroupNews"
						class="col-md-1 col-md-offset-7 knowmore fontsize_20 font_600 text_grey"
					>更多资讯></div>
				</div>
				<!-- 要闻正文 -->
				<div class="content col-md-10 col-md-offset-1">
					<!-- jet0104 设置左侧图片高度615px右侧内容高度652px,实现左右两侧高度相同!!! -->
					<div class="newsPhoto col-md-6 p_16">
						<el-image style="width:100%; height:615px" :src="currentInformation.navImg" fit="fill"></el-image>
					</div>
					<div style="height: 652px" class="newsContent col-md-6 w_100 p_16 flex flex_column justify_between align_left wow zoomIn">
						<div
              				@click="goToNewsDetail(item.id)"
							v-for="item,index in currentInformation.newsList"
							:key="index"
							class="newsItem w_100 wow bounceInRight"
						>
							<div
								class="left w_20 color_fff bg_blue flex flex_column justify_between align_center pt_36 pb_36"
							>
								<div class="fontsize_40">{{item.day}}</div>
								<div class="fontsize_20">{{item.month}}</div>
							</div>
							<div class="right w_80 flex flex_column justify_between align_start p_10">
								<div
									style="min-height:70px"
									class="itemTitle fontsize_24 color_000 line_height_normal font_600 text_ellipsis_2"
									:class="{color_blue: index == 0}"
								>{{item.title}}</div>
								<div
									class="fontsize_18 text_gray line_height_normal font_500 text_ellipsis_2 mt_10"
								>{{item.desc}}</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<!-- 手机端 -->
			<div id="information_xs" class="row visible-xs visible-sm">
				<!-- 标签 -->
				<div class="tag col-xs-10 col-xs-offset-1 wow bounceInDown">
					<div class="title fontsize_24 font_bold w_100 color_blue text_center">
						杰出资讯
						<span class="green">Group information</span>
					</div>
				</div>
				<!-- 菜单分类 -->
				<div class="navItem col-xs-10 col-xs-offset-1 mt_20 pt_10 pb_10">
					<div class="col-xs-12">
						<div class="navTitle fontsize_20 font_600">
							<span
								v-for="item,index in informationNavItemList"
								:key="index"
								@click="changeNavItem(index)"
								class="font_600 wow zoomInLeft"
								:class="{color_blue: currentIndex == index}"
							>{{item.navName}}</span>
						</div>
					</div>
					<div
						@click="goToGroupNews"
						class="col-xs-4 knowmore fontsize_14 font_500 text_grey mt_12"
					>更多资讯></div>
				</div>
				<!-- 要闻正文 -->
				<div class="content col-xs-10 col-xs-offset-1">
					<div class="newsPhoto col-xs-12 p_16">
						<el-image style="width:100%; height:auto" :src="currentInformation.navImg" fit="contain"></el-image>
					</div>
					<div class="newsContent col-xs-12 w_100 flex flex_column justify_start align_left wow zoomIn">
						<div
              				@click="goToNewsDetail(item.id)"
							v-for="item,index in currentInformation.newsList"
							:key="index"
							class="newsItem w_100 wow bounceInRight pt_10 pb_10"
						>
							<div
								class="left w_20 color_fff bg_blue flex flex_column justify_between align_center pt_36 pb_36"
							>
								<div class="fontsize_20">{{item.day}}</div>
								<div class="fontsize_14">{{item.month}}</div>
							</div>
							<div class="right w_80 flex flex_column justify_between align_start p_10">
								<div
									class="itemTitle fontsize_18 color_000 line_height_normal font_600 text_ellipsis_2"
									:class="{color_blue: index == 0}"
								>{{item.title}}</div>
								<div
									class="fontsize_14 text_gray line_height_normal font_500 text_ellipsis_2 mt_10"
								>{{item.desc}}</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- 合作伙伴 -->
		<div id="partners" class="container-fuild mt_36">
			<!-- 电脑端 -->
			<div id="partners_md" class="row hidden-xs hidden-sm">
				<!-- 标签 -->
				<div class="tag col-md-6 col-md-offset-3 wow bounceInDown">
					<div class="title fontsize_40 font_bold w_100 color_blue text_center">
						合作伙伴
						<span class="green">Group partners</span>
					</div>
				</div>
				<!-- 正文 -->
				<div class="content col-md-10 col-md-offset-1 mt_60 wow zoomIn">
					<el-image
						style="width:100%; height:auto"
						:src="require('@/assets/img/partners.png')"
						fit="contain"
					></el-image>
				</div>
			</div>

			<!-- 手机端 -->
			<div id="partners_xs" class="row visible-xs visible-sm">
				<!-- 标签 -->
				<div class="tag col-xs-10 col-xs-offset-1 wow bounceInDown">
					<div class="title fontsize_24 font_bold w_100 color_blue text_center">
						合作伙伴
						<span class="green">Group partners</span>
					</div>
				</div>
				<!-- 正文 -->
				<div class="content col-xs-10 col-xs-offset-1 mt_20 wow zoomIn">
					<el-image
						style="width:100%; height:auto"
						:src="require('@/assets/img/partners.png')"
						fit="contain"
					></el-image>
				</div>
			</div>
		</div>

		<!-- 您身边的人力资源专家 -->
		<div id="contactUs" class="container-fuild flex flex_column justify_center align_center text-center">
			<div class="container contactUs-container wow slideInUp">
				<h1>做客户认可的人才服务供应商</h1>
				<h3>用自己创造的机会成就自己</h3>
				<el-button type="primary" @click="goToMeetJiechu(2)" :round="true" size="medium">联系我们</el-button>
				<!-- <div class="contactUs-contactWay">
					<span></span>
					<span></span>
					<span></span>
				</div> -->
			</div>
		</div>
	</div>
</template>
<script>
import Swiper from "swiper"; //swiper滚动播放js
import { WOW } from 'wowjs'; //animate.css配套动画js
import ICountUp from "vue-countup-v2"; //jet1207 引入数字动画组件
export default {
  name: "HomePage",
  components: {
		ICountUp,
	},
  data() {
    return {
      // 轮播图列表
      carouselList: [
        {
          img: require("@/assets/img/banner1.png"),
          path: "",
          title: '商务协调团队',
          content: '协助银行、信托交易所、证券交易客户方案选型，梳理客户需求等工作',
        },
        {
          img: require("@/assets/img/banner2.png"),
          path: "",
          title: '售后服务团队',
          content: '受理用户的系统建设，以现场+远程的方式进行服务，负责跟进客户系统使用情况',
        },
        {
          img: require("@/assets/img/banner3.png"),
          path: "",
          title: '培训讲师团队',
          content: '以现场、远程等方式完成系统操作培训，收集用户使用反馈',
        },
      ],

      // 概览数据
      summaryList:[
        {
          name: '服务年限',
          unit: '年+',
          val: '15'
        },
        {
          name: '下设分支机构',
          unit: '家',
          val: '27'
        },
        {
          name: '业务覆盖城市',
          unit: '+',
          val: '50'
        },
        {
          name: '服务企业个数',
          unit: '+',
          val: '2000'
        },
        {
          name: '安置就业人数',
          unit: '万+',
          val: '50'
        },
        {
          name: '近三年营收',
          unit: '亿元',
          val: '69'
        },
      ],

      //CountUp配置选项
	  CountUpOptions: {
			useEasing: true,
			useGrouping: true,
			separator: ',',
			decimal: '.',
			prefix: '',
			suffix: ''
      },

      //集团业务
      businessList1:[
        {
          index: 0,
          name: '园区运营',
          img: require('@/assets/img/business1.png'),
		  imgHover: require('@/assets/img/business1_active.png'),
          desc: '山东杰出人才发展集团提供全链条、一体化、标准化、智能化产业运营服务体系，针对各园区...'
        },
        {
          index: 1,
          name: '企业管理咨询',
          img: require('@/assets/img/business2.png'),
		  imgHover: require('@/assets/img/business2_active.png'),
          desc: '基于杰出集团十余年来在人力资源行业的专业积累，为企业提供人力资源管理诊断与战略规划...'
        },
        {
          index: 2,
          name: '人力资源技术开发应用',
          img: require('@/assets/img/business3.png'),
		  imgHover: require('@/assets/img/business3_active.png'),
          desc: '杰出集团拥有专业技术研发团队和模块开发团队，掌握专业技术，可根据企业具体需要，提供...'
        },
      ],
      businessList2:[
        {
          index: 3,
          name: '人才派遣与服务外包',
          img: require('@/assets/img/business4.png'),
		  imgHover: require('@/assets/img/business4_active.png'),
          desc: '杰出集团利用专业资源，为企业提供定制化人才派遣以及组织内部业务活动或流程的设计...'
        },
        {
          index: 4,
          name: '职业培训与技能鉴定',
          img: require('@/assets/img/business5.png'),
		  imgHover: require('@/assets/img/business5_active.png'),
          desc: '山东杰出人才发展集团有限公司旗下全资子公司——日照杰出培训学校，成立...'
        },
        {
          index: 5,
          name: '品牌与标准化服务',
          img: require('@/assets/img/business6.png'),
		  imgHover: require('@/assets/img/business6_active.png'),
          desc: '杰出集团深耕人力资源行业十余年间，始终坚持企业的自主创新、重视自主品牌建设、厚植...'
        },
        { index: 6,
          name: '生命大健康',
          img: require('@/assets/img/business7.png'),
		  imgHover: require('@/assets/img/business7_active.png'),
          desc: '杰出集团坚持“健康是人才发展的基石”的发展理念，应用现代医疗和信息技术，从生理、心理角度...'
        }
      ],

      currentIndex: 0, //当前新闻菜单下标
      currentInformation: {}, //当前新闻列表
      //总新闻列表
      informationNavItemList:[
        {
          navName: '集团要闻 | ',
          type: 7,
        },
        {
          navName: '行业资讯 | ',
          type: 8,
        },
        {
          navName: '相关政策',
          type: 9,
        },
      ],


      // swiperList: [
      //   {
      //     img: require("@/assets/img/test1.png"),
      //     path: "",
      //     title: '商务协调团队',
      //     content: '协助银行、信托交易所、证券交易客户方案选型，梳理客户需求等工作',
      //   },
      //   {
      //     img: require("@/assets/img/test2.jpg"),
      //     path: "",
      //     title: '售后服务团队',
      //     content: '受理用户的系统建设，以现场+远程的方式进行服务，负责跟进客户系统使用情况',
      //   },
      //   {
      //     img: require("@/assets/img/test3.jpg"),
      //     path: "",
      //     title: '培训讲师团队',
      //     content: '以现场、远程等方式完成系统操作培训，收集用户使用反馈',
      //   },
      //   {
      //     img: require("@/assets/img/test1.png"),
      //     path: "",
      //     title: '系统开发团队',
      //     content: '对客户需求进行持续响应，保证系统满足用户业务动态发展的需要',
      //   }
      // ],
    };
  },

  //vue实例完成
  created(){
    //初始赋值集团新闻【类型7】
    this.getGroupNewsMain(7);
  },

  // 页面渲染完成
  mounted() {

    /*jet1207 banner-swiper轮播 注释暂存 */
    // new Swiper(".banner-swiper", {
    //   loop: true, // 循环模式选项
    //   effect: 'fade',
    //   //自动播放
    //   autoplay: {
    //     delay: 3000,
    //     stopOnLastSlide: false,
    //     disableOnInteraction: false
    //   },
    //   // 如果需要分页器
    //   pagination: {
    //     el: ".swiper-pagination",
    //     clickable: true
    //   },
    //   // 如果需要前进后退按钮
    //   navigation: {
    //     nextEl: ".swiper-button-next",
    //     prevEl: ".swiper-button-prev"
    //   },
    //   // 延迟加载
    //   lazy: {
    //     loadPrevNext: true
    //   },
    //   observer: true, //修改swiper自己或子元素时，自动初始化swiper
    //   observeParents: true //修改swiper的父元素时，自动初始化swiper
    // });

    /* wowjs动画 */
    var wow = new WOW({
      boxClass: 'wow',
      animateClass: 'animated',
      offset: 0,
      mobile: true,
      live: true
    })
    wow.init();


  },
  methods: {
    // 切换新闻菜单
    changeNavItem: function(index){
      this.currentIndex = index; //赋值当前下标
      const type =  this.informationNavItemList[index].type;
      console.log('切换新闻类型 type='+type);

      //获取当前分类新闻
      this.getGroupNewsMain(type);
    },

    //跳转关于集团
    goToAboutGroup(){
      this.$router.push({
        name: 'aboutgroup',
        params: {}
      })
    },

    //跳转七大业务
    goToGroupBusiness(param){
      console.log('跳转七大业务参数index=',param)
      this.$router.push({
        name: 'groupbusiness',
        params: {
          index: param
        }
      })
    },

    //跳转杰出资讯
    goToGroupNews(){
      this.$router.push({
        name: 'groupnews',
        params: {}
      })
    },

    //跳转杰出资讯详情
    goToNewsDetail(param){
      console.log('跳转新闻详情id='+param)
      this.$router.push({
        name: 'groupnewsdetail',
        params: {
          id: param,
          index: this.currentIndex,
         }
      })
    },

    //获取集团咨询摘要
    getGroupNewsMain(param){
      let that = this;
      //执行接口请求
      this.$axios.get('https://api.jiechuhr.com/web/api/home/news/latest', {
        params: {
          type: param,
        }
      }).then(function ({data: res}) {
        console.log("集团新闻摘要回调=>",res);
        if (res.code === 0) {
					that.currentInformation = res.data;
					console.log("currentInformation=>", that.currentInformation);
				} else {
					// return this.$message.error(res.msg);
				}
      }).catch(function (error) {
        console.log(error);
      });
            
    },

    //跳转联系我们
    goToMeetJiechu(param) {
      this.$router.push({
        name: 'meetjiechu',
        params: {
          index: param,
         }
      })
    },
  }
};
</script>
<style scoped>
/* 整体盒子 */
#HomePage {
	width: 100%;
}
.color_blue {
	color: #245998 !important;
}
.bg_blue {
	background-color: #245998 !important;
}
.text_gray {
	color: #6a6a6a;
}
.el-button--primary {
	font-size: 16px;
}

/* 轮播图 */
#swiper {
	/* height: 600px; */
	height: 1080px;
	z-index: 1;
}

#swiper .banner-swiper {
	width: 100%;
	height: 100%;
}
#swiper .banner-swiper .swiper-slide img {
	width: 100%;
	height: 100%;
}
#swiper .banner-swiper .swiper-slide {
	position: relative;
}
#swiper .banner-swiper .swiper-slide-title {
	position: absolute;
	top: 0;
	left: 0;
	z-index: 999999999;
	width: 100%;
	height: 100%;
	color: #fff;
	background: rgba(51, 51, 51, 0.534);
	text-align: center;
	line-height: 80px;
}
#swiper .banner-swiper .swiper-slide-title > h1 {
	font-size: 50px;
	margin-top: 12%;
}
#swiper .banner-swiper .swiper-slide-title > p {
	font-size: 20px;
	margin-top: 1%;
	font-weight: 700;
}

/* 公司简介 */
#desc {
	transition: all ease 0.6s;
	box-sizing: border-box;
	left: 0px;
	top: 80%;
	width: 100%;
	height: 500px;
	z-index: 10;
}
/* 简介内容电脑端 */
#desc .description_md {
	padding: 45px 65px;
	box-shadow: 5px 15px 15px #efefef;
	background-color: #fff;
	border-radius: 5px;
}

/* 公司简介设置媒体查询 */

/* 小于1920*/
@media screen and (min-width: 1920px) and (max-width:3840px){
	.description_md .content .groupdesc{
		height: 318px;
	}
	.description_md .content .el-image{
		height: 298px !important;
	}
}

/* 小于1080 */
@media screen and (min-width: 600px) and (max-width:1920px){
	.description_md .content .groupdesc{
		height: 250px;
	}
	.description_md .content .el-image{
		height: 230px !important;
	}
}


#desc .description_md .content .knowmore:hover {
	color: #245998 !important;
	font-weight: 600;
	cursor: pointer;
}
/* 简介内容手机端 */
#desc .description_xs {
	padding: 20px 30px;
	box-shadow: 5px 15px 15px #efefef;
	background-color: #fff;
	border-radius: 5px;
}
#desc .description_xs .content .knowmore:hover {
	color: #245998 !important;
	font-weight: 600;
	cursor: pointer;
}

/*引入数字字体 */
@font-face {
	font-family: "Digital";
	src: url("../assets/fonts/digital-font/DS-Digital.ttf");
}
#summary_md .number {
	font-family: "Digital";
}
#summary_xs .number {
	font-family: "Digital";
}

/* 统计数据电脑端 */
#summary_md {
	transition: all ease 0.6s;
	box-sizing: border-box;
	/* margin-top: 300px; */
	margin-top: 250px;
	padding: 80px 0px;
	background-color: #fff;
}

/* 统计数据电脑端 */
#summary_xs {
	transition: all ease 0.6s;
	box-sizing: border-box;
	margin-top: 540px;
	padding: 15px 0px;
	background-color: #fff;
}

/* 集团业务 */
#business {
	transition: all ease 0.6s;
	box-sizing: border-box;
}

/* 集团业务内容电脑端 */
#business_md .content {
}
#business_md .title {
	background: url("../assets/img/business.png") no-repeat center center;
	background-size: cover;
	height: 136px;
	line-height: 136px;
}
#business_md .content .item {
	padding: 10px 30px;
	box-shadow: 5px 15px 15px #efefef;
	background-color: #fff;
	border-radius: 10px;
	min-height: 335px;
	transition: all 1.5s linear 0s; /*设置延迟动画 */
}

/* 鼠标移入上移并切换背景色 */
#business_md .content .item:hover {
	background-color: #245998 !important;
	color: #fff !important;
	transform: translateY(-20px);
	cursor: pointer;
}
/* 鼠标移入字体变色 */
#business_md .content .item:hover .color_blue {
	color: #fff !important;
}
#business_md .content .item:hover .text_gray {
	color: #fff !important;
}
#business_md .content .item:hover .green {
	color: #fff !important;
}

/* jet1228 设置鼠标移入切换图片 */
#business_md .content .item .businessImg{
	display: inline-block;
}
#business_md .content .item .businessImgHover{
	display: none;
}
#business_md .content .item:hover .businessImg{
	display: none;
}
#business_md .content .item:hover .businessImgHover{
	display: inline-block;
}


/* 集团业务内容手机端 */
#business_xs .title {
	background: url("../assets/img/business.png") no-repeat center center;
	background-size: cover;
	height: 80px;
	line-height: 80px;
}

#business_xs .content .item {
	padding: 10px 30px;
	box-shadow: 5px 15px 15px #efefef;
	background-color: #fff;
	border-radius: 10px;
	min-height: 335px;
	transition: all 1.5s linear 0s; /*设置延迟动画 */
}

/* 鼠标移入上移并切换背景色 */
#business_xs .content .item:hover {
	background-color: #245998 !important;
	color: #fff !important;
	transform: translateY(-20px);
	cursor: pointer;
}
/* jet1228 设置鼠标移入切换图片 */
#business_xs .content .item .businessImg{
	display: inline-block;
}
#business_xs .content .item .businessImgHover{
	display: none;
}
#business_xs .content .item:hover .businessImg{
	display: none;
}
#business_xs .content .item:hover .businessImgHover{
	display: inline-block;
}

/* 鼠标移入字体变色 */
#business_xs .content .item:hover .color_blue {
	color: #fff !important;
}
#business_xs .content .item:hover .text_gray {
	color: #fff !important;
}
#business_xs .content .item:hover .green {
	color: #fff !important;
}




/* 业务版图 */
#territory {
	transition: all ease 0.6s;
	box-sizing: border-box;
}

/* 集团资讯 */
#information {
	transition: all ease 0.6s;
	box-sizing: border-box;
}
#information .navItem .navTitle:hover {
	cursor: pointer;
}
#information .content .newsContent .newsItem {
	transition: all 1.5s linear 0s; /*设置延迟动画 */
}
#information .navItem .knowmore:hover {
	cursor: pointer;
	color: #245998 !important;
}

#information .content .newsContent .newsItem:hover .right .itemTitle {
	color: #245998 !important;
	cursor: pointer;
}

/* jet0104 鼠标移入其他选项时首个内容标题颜色恢复黑色，测试失败 */
#information .content .newsContent .newsItem:hover :first-of-type .right .itemTitle{
	color: #333 !important;
	cursor: pointer;
}


/* 集团资讯电脑端 */
#information_md .title {
	background: url("../assets/img/business.png") no-repeat center center;
	background-size: cover;
	height: 136px;
	line-height: 136px;
}

/* 集团资讯手机端 */
#information_xs .title {
	background: url("../assets/img/business.png") no-repeat center center;
	background-size: cover;
	height: 80px;
	line-height: 80px;
}

/* 合作伙伴 */
#partners {
	transition: all ease 0.6s;
	box-sizing: border-box;
}
/* 合作伙伴电脑端 */
#partners_md .title {
	background: url("../assets/img/business.png") no-repeat center center;
	background-size: cover;
	height: 136px;
	line-height: 136px;
}
/* 合作伙伴手机端 */
#partners_xs .title {
	background: url("../assets/img/business.png") no-repeat center center;
	background-size: cover;
	height: 80px;
	line-height: 80px;
}

/* 大数据管理系统 */
#bigData {
	padding: 100px;
	transition: all ease 0.6s;
	box-sizing: border-box;
}
#bigData .bigData-title {
	padding-bottom: 10px;
	border-bottom: 1px solid #ccc;
}
#bigData p {
	font-size: 14px;
	color: #333;
	line-height: 2rem;
}
#bigData .bigData-device {
	margin: 50px 0 20px;
}

/* 您身边的人力资源专家 */
#contactUs {
	color: #fff;
	height: 400px;
	background: url("../assets/img/contact_us_bg.jpg") 0 0 no-repeat;
	background-size: 100% 100%;
	transition: all ease 0.6s;
}
#contactUs .contactUs-container {
	/* padding-top: 50px; */
}
#contactUs .contactUs-container button {
	width: 300px;
	height: 50px;
	margin-top: 40px;
}
#contactUs .contactUs-container .contactUs-contactWay span {
	display: inline-block;
	width: 48px;
	height: 48px;
	margin: 30px;
}
#contactUs .contactUs-container .contactUs-contactWay span:nth-of-type(1) {
	background: url("../assets/img/weixin.png") 0 0 no-repeat;
	background-size: 100% 100%;
}
#contactUs .contactUs-container .contactUs-contactWay span:nth-of-type(2) {
	background: url("../assets/img/weibo.png") 0 0 no-repeat;
	background-size: 100% 100%;
}
#contactUs .contactUs-container .contactUs-contactWay span:nth-of-type(3) {
	background: url("../assets/img/twitter.png") 0 0 no-repeat;
	background-size: 100% 100%;
}

/* 媒体查询（手机） */
@media screen and (max-width: 768px) {
	#swiper {
		height: 200px;
	}
	#contactUs {
		height: 200px;
		transition: all ease 0.6s;
	}
	#contactUs .contactUs-container {
		padding-top: 0;
	}
	#contactUs .contactUs-container h1 {
		font-size: 25px;
	}
	#contactUs .contactUs-container h3 {
		font-size: 18px;
	}
	#contactUs .contactUs-container button {
		width: 200px;
		height: 30px;
		margin-top: 20px;
	}
	#contactUs .contactUs-container .contactUs-contactWay span {
		display: inline-block;
		width: 28px;
		height: 28px;
		margin: 10px;
	}
}

/* 媒体查询（平板） */
@media screen and (min-width: 768px) and (max-width: 996px) {
	#swiper {
		height: 400px;
	}
	#contactUs {
		height: 300px;
	}
	#contactUs .contactUs-container {
		padding-top: 50px;
	}
	#contactUs .contactUs-container h1 {
		font-size: 30px;
	}
	#contactUs .contactUs-container h3 {
		font-size: 20px;
	}
	#contactUs .contactUs-container button {
		width: 300px;
		height: 50px;
		margin-top: 30px;
	}
	#contactUs .contactUs-container .contactUs-contactWay span {
		display: inline-block;
		width: 32px;
		height: 32px;
		margin: 15px;
	}
}
</style>




// WEBPACK FOOTER //
// src/view/HomePage.vue